import { Badge, Box, FormControl, FormHelperText, FormLabel, HStack, Icon, Spinner, Text } from '@chakra-ui/react';
import { FaCashRegister } from 'react-icons/fa';
import { formatSaldoExibicao, getSaldoContaRaw, isContaCaixa } from './contaCaixaReforcoUtils';

// A conta é fixa: reforço sempre utiliza a única conta caixa da clínica.
function ContaCaixaReforcoSelect({ contas = [], caixaAberto = false, saldoCaixaReal = 0, loadingSaldoCaixa = false, loading = false, alignStretch = false }) {
  const caixas = contas.filter(isContaCaixa);
  const conta = caixas.length === 1 && caixas[0].ativa !== false ? caixas[0] : null;
  const cor = caixaAberto ? 'green' : 'orange';
  return (
    <FormControl display="flex" flexDirection="column" flex={alignStretch ? 1 : undefined}>
      <FormLabel mb={1} fontSize="sm">Conta caixa</FormLabel>
      {loading ? <Box p={3}><Spinner size="sm" /><Text fontSize="sm">Carregando conta caixa...</Text></Box> : conta ? (
        <HStack align="flex-start" spacing={2} p={3} flex={1} borderWidth="1px" borderColor={`${cor}.300`} borderRadius="md" bg={`${cor}.50`}>
          <Icon as={FaCashRegister} color="gray.500" mt={1} />
          <Box flex={1} minW={0}>
            <HStack justify="space-between" flexWrap="wrap">
              <Text fontWeight="semibold">Conta caixa</Text>
              <Badge colorScheme={cor}>{caixaAberto ? 'Caixa aberto' : 'Caixa fechado'}</Badge>
            </HStack>
            <Text fontSize="sm" color="gray.600" mt={1}>Instituição 000 - Conta caixa</Text>
            <Text fontSize="xs" color="gray.600">Agência {conta.agencia || '—'} · Conta {conta.numeroConta || '—'}{conta.digitoConta ? `-${conta.digitoConta}` : ''}</Text>
            <Text fontSize="sm" fontWeight="semibold" color={`${cor}.600`} mt={1}>
              {caixaAberto && loadingSaldoCaixa ? 'Saldo: carregando...' : `Saldo: ${formatSaldoExibicao(caixaAberto ? saldoCaixaReal : getSaldoContaRaw(conta))}`}
            </Text>
          </Box>
        </HStack>
      ) : (
        <Text p={3} fontSize="sm" color="orange.700" borderWidth="1px" borderRadius="md">
          {caixas.length > 1 ? 'Há mais de uma conta caixa cadastrada. Regularize o cadastro antes de realizar o reforço.' : 'Cadastre uma conta ativa da instituição 000 - Conta caixa para realizar o reforço.'}
        </Text>
      )}
      <FormHelperText fontSize="xs" mt={1}>O reforço será destinado automaticamente à conta caixa da clínica.</FormHelperText>
    </FormControl>
  );
}
export default ContaCaixaReforcoSelect;
